export default __webpack_public_path__ + "locales/it/Settings.json?hash=c7fdaee9fd420369dff789faccf15244";